import { render, staticRenderFns } from "./wchartoauth.vue?vue&type=template&id=70c5a2a4&scoped=true&"
import script from "./wchartoauth.vue?vue&type=script&lang=js&"
export * from "./wchartoauth.vue?vue&type=script&lang=js&"
import style0 from "./wchartoauth.vue?vue&type=style&index=0&id=70c5a2a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c5a2a4",
  null
  
)

export default component.exports